import dynamic from "next/dynamic";
// import Head from "next/head";
import { useContext, useEffect, useMemo, useState } from "react";
import {
  stateLangMapper,
  stateLinkMapper,
  // defaultAuthorMap,
} from "@/utils/langCodeMapper";
//import Link from "next/link";
import SVG from "react-inlinesvg";
import HomepageCritical from "@/component/CriticalCSS/HomepageCritical";

const ShortsCarousel = dynamic(() =>
  import("@/component/Shorts/ShortsCarousel")
);
const BreakingNewsSlider = dynamic(() =>
  import("@/component/BreakingNewsSlider")
);
const HtmlWidget = dynamic(() => import("@/component/HtmlWidget"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
import defaultMetaTags from "@/constants/defaultMetaTags";
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);
const TaboolaScript = dynamic(() =>
  import("@/component/Ads/TaboolaScript", { ssr: false })
);
const ItemsListSchema = dynamic(() => import("@/component/SeoTags/ItemsList"));
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
// const RegionalNewsBox = dynamic(() => import("@/component/Regional/RegionalNewsBox"));
const StateData = dynamic(() => import("@/component/Regional/StateData"));
const NewsGrid1 = dynamic(() => import("@/component/NewsGrid/NewsGrid1"));
const NewsGrid2 = dynamic(() => import("@/component/NewsGrid/NewsGrid2"));
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
// const VDOAdsScript = dynamic(() => import("@/component/Ads/VDOAdsScript"));
// const VDOAdSlot = dynamic(() => import("@/component/Ads/VDOAdSlot"));
import { useWindowSize } from "@/hooks/useIsMobile";
// import GTMScript from "@/component/Ads/GTMScript";
// const Sponsor = dynamic(() => import("@/component/Sponsor"));
// import NavigationBar from "@/component/Navigation";
// const ExitPoll = dynamic(() => import("@/component/ExitPoll"));
// Reserve space for async widgets to prevent layout shift.
const Loading = () => (
  <div
    className="w-full my-4 rounded-md bg-gray-100 animate-pulse"
    style={{ minHeight: "280px" }}
    aria-hidden="true"
  />
);

// const ResultTally = dynamic(() => import("@/component/Result"), {
//   loading: () => <Loading />,
// });
const StateExitPoll = dynamic(() => import("@/component/StateExitPoll"), {
  loading: () => <Loading />,
});
const StateResultTally = dynamic(() => import("@/component/StateResultTally"), {
  loading: () => <Loading />,
});
const ElectionLive = dynamic(() => import("@/component/ElectionLive"), {
  loading: () => <Loading />,
});
import stateKeys from "@/constants/stateKeys";
import {
  apstagBidCallback,
  createApsSlotsHomeDesktop,
  createApsSlotsHomeMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";
import { MasterConfigContext } from "@/context/MasterConfigContext";
// import { useRouter } from "next/router";
import IPLSponsor from "@/component/IPL/IPLSponser";
import HomeBanner from "../MPbaithaki/HomeBanner";
import AsiaCupHomeBanner from "@/component/TestSeries/AsiaCupHomeBanner";
import { default as BiharHomeBanner } from "../BiharTakbaithak/HomeBanner";
import BiharConstituencyLiveResult from "@/component/constituency/BiharConstituencyLiveBlogLinks";
import BiharElectionHomeMenuBannerCard from "@/component/constituency/BiharElectionHomeMenuBannerCard";
import ExitPollTally from "../FiveStateElection/ExitPollTally";
import ElectionMainTab from "../FiveStateElection/ElectionMainTab";

import StatesConstituencyLiveResult from "../FiveStateElection/StatesConstituencyLiveResult";
import GoldSilverBanner from "@/component/GoldSilver/GoldSilverBanner";
import { useGoldSilver } from "@/context/GoldSilverContext";

const IPLBanner = dynamic(() => import("@/component/IPL/IPLBanner"));
const MatchBanner = dynamic(() => import("@/component/TestSeries/MatchBanner"));

const BoardsHomeWidget = dynamic(() =>
  import("@/component/BoardResults/BoardsHomeWidget")
);
// const ConstituencyLinks = dynamic(() =>
//   import("@/component/constituency/ConstituencyLinks")
// );
const ResultWidget = dynamic(() =>
  import("@/component/NikayChunav/ResultWidget")
);
// import ExitPollRegionalComponentV2 from "@/component/ExitPollRegionalV2";
const ExitPollRegionalComponentV2 = dynamic(() =>
  import("@/component/ExitPollRegionalV2")
);
// import KeyCandidate from "@/component/KeyCandidate";

const Home = ({
  breakingNewsData = null,
  homepageData = null,
  shortVideoData = null,
  liveVideoData = null,
  isMobileDevice = false,
  itemListData = null,
  statesNewsListData = null,
  electionLiveData = null,
  liveBlogData = null,
  constituencyList = null,
}) => {
  const masterConfig = useContext(MasterConfigContext);
  const electionKeys = masterConfig["bihar_election"];
  const hrElectionKeys = masterConfig["haryana_election"];
  const boardsKeys = masterConfig["boards_result"];
  const iplKeys = masterConfig["ipl_2025"];
  const electionPassedCategory = "assembly-chunav/bihar";
  const sportsKey = masterConfig["sportsEvent"];
  const mp_baithaki = masterConfig["mp_baithaki"];
  const bihar_baithaki = masterConfig["bihar_baithaki"];
  const tak360_banner = masterConfig["tak360_banner"];
  const showHomeBanner = masterConfig?.["assembly_widgets_2026"]?.["showHomeBanner"];
  const showHomeResultTally = masterConfig?.["assembly_widgets_2026"]?.["showHomeResultTally"];
  // console.log("Homepage data ",homepageData);
  const size = useWindowSize();
  // const [activeState , setActiveState] = useState("MP");
  // const availableStates = ["MP" , "RJ" , "HR" , "BR"]
  const keyBindings = {
    Category: ["NewsTak-homepage"],
    Keywords: homepageData?.seo_detail?.meta_keyword.split(","),
  };
 const {overview} = useGoldSilver();
 const showGoldSilverWidgetOnTopbar = masterConfig?.showGoldSilverWidgetOnTopbar;

  const stateMapKeys = useMemo(() => {
    if (statesNewsListData && Object.keys(statesNewsListData)) {
      const keys = Object.keys(statesNewsListData).filter(
        (key) => key !== "cache"
      );
      return keys;
    }
    return [];
  }, [statesNewsListData]);
  const [isScroll, setIsScroll] = useState(false);
  useEffect(() => {
    function handleScroll() {
      if (!isScroll) {
        setIsScroll(true);
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScroll]);

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };
      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          if (!isScroll) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_HP_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());
          }
          if (isScroll) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_HP_MTF-1_300x250",
                [300, 250],
                "div-gpt-ad-1659434604998-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_HP_MTF-2_300x250",
                [300, 250],
                "div-gpt-ad-1659434785315-0"
              )
              .addService(googletag.pubads());

            {
              stateMapKeys?.length > 3 &&
                googletag
                  .defineSlot(
                    "/1007232/News_tak_Mobile_HP_MTF-3_300x250",
                    [300, 250],
                    "div-gpt-ad-1659435328239-0"
                  )
                  .addService(googletag.pubads());
            }
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_HP_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());
          }
          {
            !isScroll &&
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_HP_Bottom_320x50",
                  [320, 50],
                  "div-gpt-ad-1659435612077-0"
                )
                .addService(googletag.pubads());
          }

          // // googletag.pubads().enableSingleRequest();
          // // googletag.pubads().disableInitialLoad();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
          googletag.enableServices();
          requestBiddingFromPWT();
          // Object.keys(keyBindings).forEach((key) => {
          //   googletag.pubads().setTargeting(key, keyBindings[key]);
          // });
          !isScroll &&
            googletag?.cmd.push(function () {
              var INTERSTITIALAd = googletag
                ?.defineOutOfPageSlot(
                  "/1007232/News_tak_Mobile_HP_Mweb_Interstitial",
                  googletag?.enums.OutOfPageFormat.INTERSTITIAL
                )
                ?.addService(googletag.pubads());
              INTERSTITIALAd && googletag?.display(INTERSTITIALAd);
            });
        });
      } else {
        googletag.cmd.push(function () {
          if (!isScroll) {
            googletag.destroySlots();

            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_HP_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_HP_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }
          if (isScroll) {
            // rhs mtf
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_HP_MTF_300x250",
                [300, 250],
                "div-gpt-ad-1751005897683-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_HP_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-2"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_HP_MTF_2_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-3"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_HP_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-4"
              )
              .addService(googletag.pubads());
            // rhs btf
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_HP_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1751005897683-1"
              )
              .addService(googletag.pubads());
          }

          // // googletag.pubads().enableSingleRequest();
          // // googletag.pubads().disableInitialLoad();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
          googletag.enableServices();
          requestBiddingFromPWT();
          // keyBindings &&
          //   Object.keys(keyBindings).forEach((key) => {
          //     googletag?.pubads()?.setTargeting(key, keyBindings[key]);
          //   });
        });
      }
      if (isScroll) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsHomeMobile({ mtf2: true, mtf3: false })
                : createApsSlotsHomeDesktop({
                  mtf2: true,
                  mtf3: false,
                  btf: true,
                  rhs_btf: true,
                }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
    }, 10);
  }, [isScroll]);

  const firstActive = useMemo(() => {
    let first = false;
    let firstActiveItem = "";
    electionLiveData?.content &&
      Object?.keys(electionLiveData?.content).forEach((key) => {
        if (
          first === false &&
          electionLiveData?.content?.[key]?.status === "1"
        ) {
          firstActiveItem = key;
          first = true;
        }
      });
    return firstActiveItem;
  }, []);

  return (
    <section className="mx-4">
      <HomepageCritical />
      <h1 style={{ display: "none" }}>NewsTak</h1>
      <HeadTag
        title={defaultMetaTags.title}
        description={defaultMetaTags.description}
        keywords={defaultMetaTags.keywords}
        image={`https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/brand-logo-1-ns.png`}
        canonicalUrl="https://www.newstak.in"
        lcpImage={
          homepageData?.left?.[0] &&
            homepageData?.left[0]?.[0] &&
            homepageData?.left[0][0]?.content?.[0]
            ? homepageData?.left[0][0]?.content?.[0]?.image_small +
            "?size=360:203"
            : ""
        }
      />
      {/* <GTMScript /> */}
      <WebpageSchema
        title={defaultMetaTags.title}
        description={defaultMetaTags.description}
        keywords={defaultMetaTags.keywords}
        canonicalUrl={
          process.env.NEXT_PUBLIC_WEBSITE_URL +
          homepageData?.seo_detail?.canonical_url
        }
      />
      <BreadcrumbSchema />
      <ItemsListSchema data={itemListData?.content} />
      {/* <VDOAdsScript /> */}

      {breakingNewsData && (
        <section className="my-4">
          <BreakingNewsSlider breakingNewsData={breakingNewsData} />
        </section>
      )}
      <TaboolaScript page="home" isMobile={isMobileDevice} />
      {/* {size.width !== undefined &&
        (size.width < 900 ? (
          <></>
        ) : (
          <AdSlot728x90
            divId="div-gpt-ad-1707804176041-0"
            minWidth="730px"
            minHeight="90px"
          />
        ))} */}

      {/* <Sponsor color="#EE3436" name="चुनाव" /> */}
      {/* <NavigationBar /> */}
      <AdSlot728x90
        divId="div-gpt-ad-1707804176041-0"
        minWidth="730px"
        minHeight="90px"
      />
      {electionKeys?.showHomeCategoryBanner && (
        <BiharElectionHomeMenuBannerCard
          electionKeys={electionKeys}
          electionPassedCategory={electionPassedCategory}
        />
      )}

      {hrElectionKeys?.showNikayWidget && (
        <ResultWidget isMobileDevice={isMobileDevice} />
      )}
      {/* <ExitPoll />
      <ResultTally /> */}
      <AdSlot300x250
        divId="div-gpt-ad-1659434453897-0"
        minWidth="300px"
        minHeight="250px"
      />
      {boardsKeys?.showHomeWidget && (
        <BoardsHomeWidget
          isMobileDevice={isMobileDevice}
          result10={boardsKeys?.show10result}
          result12={boardsKeys?.show12result}
          hybridResult={boardsKeys?.show10result && boardsKeys?.show12result}
          stateKey={boardsKeys?.stateKey || "mp"}
          show10form={boardsKeys?.show10form}
        />
      )}
      {mp_baithaki?.showHomePageBanner && (
        <HomeBanner masterConfigKey={mp_baithaki} />
      )}
      {showHomeBanner && <ElectionMainTab electionKeys={electionKeys} />}
      {bihar_baithaki?.showHomePageBanner && (
        <BiharHomeBanner masterConfigKey={bihar_baithaki} />
      )}
      {iplKeys?.showSponsor && (
        <IPLSponsor color="white" masterConfigKey={iplKeys} />
      )}
      {iplKeys?.showHomeBanner && <IPLBanner />}

      {sportsKey?.showBanner && <MatchBanner />}
      {sportsKey?.showAsiaCupHomeBanner && <AsiaCupHomeBanner />}
      {electionKeys?.newExitPoll && (
        <>
          <h2 className="text-2xl font-semibold my-1">एग्जिट पोल्स</h2>
          <ExitPollRegionalComponentV2 masterKey="delhi_election" />
        </>
      )}
      {electionKeys?.showExitPollTally && (
        <StateExitPoll masterKey={"bihar_election"} />
      )}

      <StateResultTally masterKey={"bihar_election"} />

      {<ExitPollTally masterKey={"assembly_widgets_2026"} />}
      {showHomeResultTally && <StateResultTally masterKey={"assembly_widgets_2026"} />}

      {/* live tv implement */}
      {<div id="livetv_one" className="show_mobile aspect-ratio-16/9">
        <ElectionLive
          electionLiveData={electionLiveData?.content}
          firstActive={firstActive}
        />
      </div>
      }
      {/* <AdSlot728x90
        divId="div-gpt-ad-1707804176041-0"
        minWidth="730px"
        minHeight="90px"
      /> */}

      {homepageData?.left?.map((item, index) => {
        return (
          <div key={index}>
            {item[0]?.widget_name === "uptak_hp_featured_1" &&
              item[0]?.info?.id != stateKeys.alpha.rjTak &&
              item[0]?.info?.id != stateKeys.alpha.hrTak &&
              item[0]?.info?.id != stateKeys.alpha.biharTak &&
              item[0]?.info?.id != stateKeys.alpha.mpTak &&
              item[0]?.info?.id != stateKeys.alpha.upTak &&
              item[0]?.info?.id != stateKeys.alpha.delhiTak &&
              item[0]?.info?.id != stateKeys.alpha.cgtak &&
              item[0]?.info?.id != stateKeys.alpha.uktak &&
              item[0]?.info?.id != stateKeys.alpha.biztak &&
              item[0]?.info?.id != stateKeys.alpha.pbTak &&
              item[0]?.content?.length > 0 && (
                <section
                  id={index}
                  key={index}
                  className="my-10 sm:my-6 xs:my-4"
                >
                  <NewsGrid1
                    newsData={item[0]}
                    isLCP={true}
                    showLiveVideo={index === 0}
                    liveVideoData={liveVideoData}
                    isMobileDevice={size.width < 900 ? true : false}
                    showAd={isMobileDevice && index === 0 ? true : false}
                  />
                </section>
              )}
{index === 1 && overview && isMobileDevice && showGoldSilverWidgetOnTopbar && (
              <GoldSilverBanner priceData={overview} showHeading={true} />
            )}
            {index == 4 && isScroll && (
              <>
                <section>
                  <AdSlot300x250
                    divId="div-gpt-ad-1659434785315-0"
                    minWidth="300px"
                    minHeight="250px"
                  />
                  <AdSlot728x90
                    divId="div-gpt-ad-1707804176041-3"
                    minWidth="728px"
                    minHeight="90px"
                  />
                  <div>
                    <div className="text-primary font-bold text-lg sm:text-xl xs:text-xl md:text-xl">
                      <h2>राज्य की खबरें </h2>
                    </div>
                    <StateData StateData={homepageData?.left} />
                  </div>
                </section>
              </>
            )}
            {index < 1 && tak360_banner?.isShowBanner && (
              <div className="w-full">
                <a
                  href={tak360_banner?.youtubeLink}
                  className="block"
                  target="_blank"
                  rel="noopener noreferrer"
                >

                  <div className="hidden md:block">
                    <img
                      src={tak360_banner?.desktopUrl}
                      alt="Tak360 Desktop Banner"
                      className="w-full h-auto"
                      width={1440}
                      height={180}
                      loading="eager"
                    />
                  </div>


                  <div className="block md:hidden">
                    <img
                      src={tak360_banner?.mobileUrl}
                      alt="Tak360 Mobile Banner"
                      className="w-full h-auto"
                      width={750}
                      height={188}
                      loading="eager"
                    />
                  </div>
                </a>
              </div>
            )}


            {/* {index == 0 && <KeyCandidate />} */}
            {item[0]?.widget_name === "uptak_hp_shorts_carousal_1" &&
              shortVideoData?.content?.length > 0 && (
                <section
                  id={index}
                  key={index + "_shorts"}
                  className="my-10 sm:my-6 xs:my-4"
                >
                  <ShortsCarousel shortVideoData={shortVideoData} />
                </section>
              )}
            {item[0]?.widget_name === "uptak_hp_category_1" &&
              item[0]?.content?.length > 0 && (
                <section id={index} key={index}>
                  <div className="my-10 sm:my-6 xs:my-4 hidden md:block lg:block">
                    <NewsGrid2
                      key={index}
                      newsData={item[0]}
                      isMobileDevice={size.width < 900 ? true : false}
                    />
                  </div>
                  <div className="my-10 sm:my-6 xs:my-4 hidden md:hidden lg:hidden sm:block mb:block xs:block md-hidden">
                    <NewsGrid1
                      key={index}
                      newsData={item[0]}
                      isMobileDevice={size.width < 900 ? true : false}
                    />
                  </div>
                </section>
              )}
            {item[0]?.widget_name === "html_widget" &&
              item[0]?.content?.length > 0 && (
                <section
                  id={index}
                  className="my-10 sm:my-6 xs:my-4"
                  key={index}
                >
                  <HtmlWidget newsData={item[0]} />
                </section>
              )}

            {/** Ads at relevant position */}
            {index === 1 && isScroll && (
              <div key={index + "_ads"} id={index}>
                <AdSlot300x250
                  divId="div-gpt-ad-1659434604998-0"
                  minWidth="300px"
                  minHeight="250px"
                />
                <AdSlot728x90
                  divId="div-gpt-ad-1707804176041-2"
                  minWidth="728px"
                  minHeight="90px"
                />
              </div>
            )}

            {index === 8 && <div key={index + "_ads"} id={index}></div>}
          </div>
        );
      })}

      {
        <>
          {isScroll &&
            stateMapKeys?.length > 0 &&
            stateMapKeys?.map((objKey, index) => {
              if (stateLangMapper[objKey] === ("यूपी" && "मुंबई")) {
                return <></>;
              } else {
                <>
                  {index === 1 && (
                    <div key={index + "_ads"} id={index}>
                      {/* <AdSlot300x250
                    divId="div-gpt-ad-1659434785315-0"
                    minWidth="300px"
                    minHeight="250px"
                  />
                  <AdSlot728x90
                    divId="div-gpt-ad-1707804176041-3"
                    minWidth="728px"
                    minHeight="90px"
                  /> */}
                    </div>
                  )}
                  {index === 2 && isScroll && (
                    <div key={index + "_ads"} id={index}>
                      <AdSlot300x250
                        divId="div-gpt-ad-1659435328239-0"
                        minWidth="300px"
                        minHeight="250px"
                      />
                    </div>
                  )}
                  <section id={"custom section"} key={objKey ?? index}>
                    <div className="my-10 sm:my-6 xs:my-4 hidden md:block lg:block">
                      <NewsGrid1
                        key={objKey}
                        newsData={{
                          content: statesNewsListData[objKey]?.slice(0, 6),
                          info: {
                            name:
                              objKey in stateLangMapper
                                ? `${stateLangMapper[objKey]} की खबरें`
                                : objKey,
                          },
                        }}
                        isMobileDevice={size.width < 900 ? true : false}
                      />
                    </div>
                    <div className="my-10 sm:my-6 xs:my-4 hidden md:hidden lg:hidden sm:block mb:block xs:block md-hidden">
                      <NewsGrid2
                        key={objKey ?? index}
                        newsData={{
                          content: statesNewsListData[objKey]?.slice(0, 6),
                          info: {
                            name:
                              objKey in stateLangMapper
                                ? `${stateLangMapper[objKey]} की खबरें`
                                : objKey,
                          },
                        }}
                        isMobileDevice={size.width < 900 ? true : false}
                      />
                    </div>
                  </section>
                  <a
                    className="flex justify-center items-center h-10 w-full my-4 border rounded-md border-gray-300 text-gray-500 hover:text-primary hover:bg-gray-100"
                    href={
                      objKey in stateLinkMapper ? stateLinkMapper[objKey] : "#"
                    }
                    target="_blank"
                  >
                    <div className="flex justify-center items-center">
                      {`${objKey in stateLangMapper
                        ? stateLangMapper[objKey]
                        : objKey
                        } की सभी खबरें`}
                      <SVG
                        className="ml-2 h-4 w-4"
                        src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/send.svg"
                      />
                    </div>
                  </a>
                </>;
              }
            })}
        </>
      }
      {isScroll && (
        <AdSlot728x90
          divId="div-gpt-ad-1707804176041-4"
          minWidth="728px"
          minHeight="90px"
        />
      )}
      {isScroll && (
        <AdSlot300x250
          divId="div-gpt-ad-1659435474737-0"
          minWidth="300px"
          minHeight="250px"
        />
      )}
      {/* five states live updates */}
      {masterConfig?.["assembly_widgets_2026"]?.autoLiveBlog && <section>
        <div className="my-8"> <StatesConstituencyLiveResult /></div>
      </section>}
      {electionKeys?.autoLiveBlog && (
        <section id={"345345"} key="99934534599">
          <div className="my-8">
            <BiharConstituencyLiveResult
              electionPassedCategory={electionPassedCategory}
              electionConfigData={electionKeys}
            />
          </div>
        </section>
      )}
      {isScroll && (
        <>
          {!isMobileDevice ? (
            <div id="taboola-below-home-thumbnails-desktop"></div>
          ) : (
            <div id="taboola-below-home-thumbnails-mobile"></div>
          )}
        </>
      )}
    </section>
  );
};

export default Home;
